import React from "react";
import { Flex } from "@chakra-ui/react";
import { CreateRegionalBlock, MedicationGroup } from "components";
import { useCurrentCase } from "duck";
import { RegionalBlockTypeEnum } from "requests";
import {
  useCreateRegionalBlock,
  useDeleteRegionalBlocks,
  useUpdateRegionalBlock
} from "./duck";

const Regional: React.FC = () => {
  const regionalBlocks = useCurrentCase(
    ({ data }) => data.client.patient.regionalBlocks
  );

  const deleteRegionalBlocks = useDeleteRegionalBlocks();
  const create = useCreateRegionalBlock();
  const updateRegionalBlock = useUpdateRegionalBlock();

  return (
    <Flex direction="column" rowGap={12}>
      <MedicationGroup.Provider update={updateRegionalBlock}>
        <MedicationGroup
          groupName="Epidural/Regional Blocks"
          medications={regionalBlocks?.filter(
            block => block?.type === RegionalBlockTypeEnum.EpiduralCalculations
          )}
          create={
            <CreateRegionalBlock
              onSubmit={values =>
                create(values, RegionalBlockTypeEnum.EpiduralCalculations)
              }
              successToast="Еpidural Calculations Medication is created successfully."
            />
          }
          onDelete={deleteRegionalBlocks}
          medicationType={RegionalBlockTypeEnum.EpiduralCalculations}
        />

        <MedicationGroup
          groupName="Regional Oral Blocks"
          medications={regionalBlocks?.filter(
            block => block?.type === RegionalBlockTypeEnum.RegionalOralBlocks
          )}
          create={
            <CreateRegionalBlock
              onSubmit={values =>
                create(values, RegionalBlockTypeEnum.RegionalOralBlocks)
              }
              successToast="Regional Oral Blocks Medication is created successfully."
            />
          }
          onDelete={deleteRegionalBlocks}
          medicationType={RegionalBlockTypeEnum.RegionalOralBlocks}
        />
      </MedicationGroup.Provider>
    </Flex>
  );
};

export default Regional;
